import { createSelector } from 'reselect';
import { IState } from '../createStore';

const selectFavoritesState = (state: IState) => state.app.persistedState.favorites;

export const selectFavoritesList = createSelector(
  [selectFavoritesState],
  (favoritesState) => favoritesState.favoritesList
);
